var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:{
    'form-group-dynamic-label': !_vm.staticLabel,
    'form-group-with-icon': _vm.icon
  },attrs:{"invalid-feedback":_vm.firstErrorMessage,"state":_vm.isValid}},[(_vm.staticLabel)?_vm._t("label",function(){return [_c('label',[_vm._v(_vm._s(_vm.label))])]}):_vm._e(),_vm._t("toggle-icon"),_vm._t("default",null,{"errors":_vm.activeErrors,"hasErrors":_vm.hasErrors,"firstErrorMessage":_vm.firstErrorMessage,"attrs":{ 
      ...(!_vm.isValid && { state: _vm.isValid }), 
      ...(_vm.hasValue && { 'has-value': 'true' })
    },"delayedListeners":{
      blur: (value) => {
        _vm.updateValue(value);
        _vm.preferredValidator.$touch();
      }
    },"listeners":{
      input: (value) => {
        _vm.updateValue(value);
        _vm.validatorTouch();
      }
    }}),(!_vm.staticLabel)?_vm._t("label",function(){return [_c('label',[_vm._v(_vm._s(_vm.label))])]}):_vm._e(),(_vm.icon)?_c('svg-icon',{staticClass:"form-group-icon",attrs:{"name":_vm.icon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }